import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "4 4 16 16",
  fill: "none",
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    fill: "none"
  }), /*#__PURE__*/_jsx("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    fill: "none"
  }), /*#__PURE__*/_jsx("g", {
    mask: "url(#mask0_2329_7063)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.81669 18C5.69447 18 5.58336 17.9694 5.48336 17.9083C5.38336 17.8472 5.30558 17.7667 5.25002 17.6667C5.19447 17.5667 5.16391 17.4583 5.15836 17.3417C5.1528 17.225 5.18336 17.1111 5.25002 17L11.4167 6.33333C11.4834 6.22222 11.5695 6.13889 11.675 6.08333C11.7806 6.02778 11.8889 6 12 6C12.1111 6 12.2195 6.02778 12.325 6.08333C12.4306 6.13889 12.5167 6.22222 12.5834 6.33333L18.75 17C18.8167 17.1111 18.8472 17.225 18.8417 17.3417C18.8361 17.4583 18.8056 17.5667 18.75 17.6667C18.6945 17.7667 18.6167 17.8472 18.5167 17.9083C18.4167 17.9694 18.3056 18 18.1834 18H5.81669ZM12 16C12.1889 16 12.3472 15.9361 12.475 15.8083C12.6028 15.6806 12.6667 15.5222 12.6667 15.3333C12.6667 15.1444 12.6028 14.9861 12.475 14.8583C12.3472 14.7306 12.1889 14.6667 12 14.6667C11.8111 14.6667 11.6528 14.7306 11.525 14.8583C11.3972 14.9861 11.3334 15.1444 11.3334 15.3333C11.3334 15.5222 11.3972 15.6806 11.525 15.8083C11.6528 15.9361 11.8111 16 12 16ZM12 14C12.1889 14 12.3472 13.9361 12.475 13.8083C12.6028 13.6806 12.6667 13.5222 12.6667 13.3333V11.3333C12.6667 11.1444 12.6028 10.9861 12.475 10.8583C12.3472 10.7306 12.1889 10.6667 12 10.6667C11.8111 10.6667 11.6528 10.7306 11.525 10.8583C11.3972 10.9861 11.3334 11.1444 11.3334 11.3333V13.3333C11.3334 13.5222 11.3972 13.6806 11.525 13.8083C11.6528 13.9361 11.8111 14 12 14Z",
      fill: "#DC6803"
    })
  })]
}), "WarningHistoryFilled");